export enum SortType {
  Name = 0,
  ModifiedDate = 1,
}

export interface SortParameters {
  SortType: SortType;
  Ascending: boolean;
  Name: string;
}
